import Raven from 'raven-js';

export function LocationService($http, $q, $rootScope, $window, orderInfoService) {
    'ngInject';

    var data = {};

    var svc = {
        data: data,
        getCurrentLocation: getCurrentLocation,
        setLocation: setLocation,
        verifyDeliveryRange: verifyDeliveryRange,
        queryAutocompleteService: queryAutocompleteService
    };
    return svc;

    function getCurrentLocation() {
        const dfd = $q.defer();

        function _onError(err) {
            dfd.reject(err);
        }

        function _onSuccess(position) {
            function _onReverseGeocodeSuccess(response) {
                if (response.data.status === 'OK') {
                    const result = response.data.results[0];
                    if (result) {
                        setLocation(
                            position.coords.latitude,
                            position.coords.longitude,
                            {
                                fromLocalStorage: undefined,
                                fromGoogleAPI: {
                                    addressComponents: result.address_components,
                                    formattedAddress: result.formatted_address
                                }
                            }
                        );
                        verifyDeliveryRange();
                        dfd.resolve();
                    } else {
                        Raven.captureMessage('No results found from Google Geocoder with lat=' + data.latitude + ', lng=' + data.longitude, {
                            level: 'info'
                        });
                        dfd.reject();
                    }
                } else {
                    Raven.captureMessage('Google Geocoder failed due to ' + response.data.status + ', error_message: ' + response.data.error_message, {
                        level: 'info'
                    });
                    dfd.reject();
                }
            }

            _reverseGeocode(position.coords.latitude, position.coords.longitude)
                .then(_onReverseGeocodeSuccess);
        }

        if ($window.navigator.geolocation) {
            $window.navigator.geolocation.getCurrentPosition(_onSuccess, _onError, { timeout: 5000 });
        } else {
            _onError('Location Services are not available');
        }
        return dfd.promise;
    }

    function setLocation(latitude, longitude, addressComponents) {
        data.latitude = latitude;
        data.longitude = longitude;

        if (addressComponents.fromLocalStorage) {
            data.address = _parseAddressInfoFromLocalStorage(addressComponents.fromLocalStorage);
        } else if (addressComponents.fromGoogleAPI) {
            data.address = addressComponents.fromGoogleAPI.formattedAddress;
            _saveLocation(addressComponents.fromGoogleAPI.addressComponents);
        }
        data.savedAddress = data.address;
    }

    function verifyDeliveryRange(latitude = data.latitude, longitude = data.longitude) {
        return $http({
            method: 'GET',
            url: 'validatelocation',
            params: {
                latitude: latitude,
                longitude: longitude
            }
        }).then(response => {
            data.inDeliveryRange = response.data.isAcceptable;

            if(data.inDeliveryRange) return $q.resolve(response.data);

            let message = 'You are out of delivery range for this restaurant.';
            return $q.reject({ message });
        });
    }

    function _parseAddressInfoFromLocalStorage(addressInfo) {
        return [
            addressInfo.streetAddress1,
            addressInfo.streetAddress2,
            addressInfo.city,
            addressInfo.state,
            addressInfo.zipCode
        ].filter(Boolean).join(', ');
    }

    function _saveLocation(addressComponents) {
        const addressInfo = {
            streetAddress1: '',
            streetAddress2: '',
            city: '',
            state: '',
            zipCode: '',
            latitude: data.latitude,
            longitude: data.longitude
        };

        addressComponents.forEach(
            component => {
                const type = component.types[0]; // TODO: there might be more than 1 type in component.types, perhaps we need a finer grain helper method to search in component.types for what we're looking for instead of getting the first element
                switch (type) {
                case 'street_number':
                    addressInfo.streetAddress1 = component.long_name;
                    break;
                case 'route':
                    addressInfo.streetAddress1 += ' ' + component.short_name;
                    break;
                case 'locality':
                    addressInfo.city = component.long_name;
                    break;
                case 'administrative_area_level_1':
                    addressInfo.state = component.short_name;
                    break;
                case 'postal_code':
                    addressInfo.zipCode = component.long_name;
                    break;
                default:
                }
            }
        );

        orderInfoService.setDeliveryInfoData(addressInfo);
    }

    function queryAutocompleteService(input) {
        const dfd = $q.defer();

        function _placePredictionsCallBack(predictions, status) {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                const place = predictions[0];
                data.placesService.getDetails(
                    { placeId: place.place_id },
                    details => {
                        setLocation(
                            details.geometry.location.lat(),
                            details.geometry.location.lng(),
                            {
                                fromLocalStorage: undefined,
                                fromGoogleAPI: {
                                    addressComponents: details.address_components,
                                    formattedAddress: details.formatted_address
                                }
                            }
                        );
                        dfd.resolve();
                    }
                );
            }
        }

        if (input === '') {
            dfd.reject();
            return dfd.promise;
        }

        var autocompleteService = new google.maps.places.AutocompleteService();
        autocompleteService.getPlacePredictions(
            {
                input: input,
                types: ['geocode']
            },
            _placePredictionsCallBack
        );

        return dfd.promise;
    }

    function _reverseGeocode(latitude, longitude) {
        return $http({
            method: 'GET',
            url: 'https://maps.googleapis.com/maps/api/geocode/json',
            params: {
                latlng: latitude + ',' + longitude,
                result_type: 'street_address', //eslint-disable-line
                key: $rootScope.googleAPIKey
            }
        });
    }
}
